export default function () {
  const widgetName = 'xmasCountdown';
  const widgetOpts = xmasCountdownOpts;

  function getDate(widgetDate) {
    const [month, day, year] = widgetDate.split('-');
    const date = new Date(Date.UTC(year, month - 1, day));
    return date;
  }

  function compareDates(widgetDate) {
    const today = new Date();
    const eventDate = getDate(widgetDate);
    const timeDiff = eventDate.getTime() - today.getTime();
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
    return days;
  }

  function countdownTemplate(widgetDate) {
    if (widgetDate.length < 1) {
      $(`#${widgetName}`).remove();
      return;
    }
    const daysAway = compareDates(widgetDate[0].Title);
    console.log(daysAway);
    const widget = $(`#${widgetName}`);
    const title = widget.find('.card-widget-title');
    widget.find('.buttonwrap').remove();

    const calendarTemplate = `
    <span class="countdown-title">${daysAway === 0 ? `TODAY` : `DAYS TO GO`}</span>
    <span class="countdown-days">${daysAway}</span>
    `;

    if (daysAway >= 0) {
      title.html(calendarTemplate);
    } else {
      widget.remove();
    }
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      countdownTemplate(data.items);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
